import React from 'react'
import {Box, VStack, HStack, Skeleton, SkeletonText, SkeletonCircle} from '@chakra-ui/react'
import LoadingSpinner from '../../loading-spinner'

const EngravingSkeleton = () => {
    return (
        <VStack align="stretch" spacing={6} p={4}>
            <LoadingSpinner position="absolute" top="auto" displayOverlay="none" />
            {/* Header */}
            <HStack justify="space-between">
                <Skeleton height="20px" width="100px" />
                <SkeletonCircle size="6" />
            </HStack>

            <Skeleton height="2px" />

            {/* Tabs */}
            <HStack spacing={4}>
                <Skeleton height="30px" width="60px" rounded="md" />
                <Skeleton height="30px" width="60px" rounded="md" />
                <Skeleton height="30px" width="60px" rounded="md" />
            </HStack>

            {/* Product Image */}
            <Box textAlign="center">
                <Skeleton colorPalette="teal" height="190px" width="190px" mx="auto" rounded="md" />
            </Box>

            {/* Font Section */}
            <Box>
                <Skeleton height="20px" width="50px" mb={2} />
                <HStack spacing={4}>
                    <Skeleton height="40px" width="100px" rounded="md" />
                    <Skeleton height="40px" width="100px" rounded="md" />
                    <Skeleton height="40px" width="100px" rounded="md" />
                </HStack>
            </Box>

            {/* Line Section */}
            <HStack justify="space-between">
                <Skeleton height="20px" width="80px" />
                <Skeleton height="20px" width="100px" />
            </HStack>

            {/* Disclaimer */}
            <Box>
                <SkeletonText mt="4" noOfLines={4} spacing="3" />
            </Box>

            <Skeleton height="2px" />

            {/* Buttons */}
            <VStack spacing={4}>
                <Skeleton height="50px" width="100%" rounded="full" />
                <Skeleton height="50px" width="100%" rounded="full" />
                <Skeleton height="20px" width="120px" />
            </VStack>
        </VStack>
    )
}

export default EngravingSkeleton
